import { firebaseFunctions } from '../../../config/firebaseConfig'

const integrationsAsyncProcess = firebaseFunctions.httpsCallable(
  'integrationsAsyncProcess'
)

export default integrationsAsyncProcess
